module.exports = __webpack_public_path__ + "static/img/slider2.88f966d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slider2.png
// module id = I4ib
// module chunks = 1